module.exports = __webpack_public_path__ + "img/home-second-4.b64babe4.jpg";